import styled from "styled-components";
import {
  PrimaryButton,
  gradientTextStyles,
  primaryAccentGradientTextStyles,
  theme,
  typography,
} from "../Homepage/styles";

export const FaqContent = styled.section`
  padding: 104px 16px 48px;

  @media (min-width: 768px) {
    padding: 128px 24px 64px;
  }
`;

export const FaqContentInner = styled.div`
  max-width: 896px;
  margin: 0 auto;
`;

export const FaqSectionBlock = styled.div`
  &:not(:last-of-type) {
    margin-bottom: 48px;
  }

  @media (min-width: 768px) {
    &:not(:last-of-type) {
      margin-bottom: 64px;
    }
  }
`;

export const FaqSectionTitle = styled.h2`
  margin: 0 0 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid hsl(var(--hp-border) / 0.6);
  font-family: ${typography.fontFamily};
  font-size: 1.5rem; /* text-2xl */
  font-weight: ${typography.weights.bold};
  line-height: 1.25;
  letter-spacing: ${typography.tracking.normal};

  @media (min-width: 768px) {
    font-size: 1.875rem; /* text-3xl */
  }

  span {
    ${primaryAccentGradientTextStyles}
  }
`;

export const FaqAccordion = styled.div`
  width: 100%;
`;

export const FaqAccordionItem = styled.div`
  border-bottom: 1px solid ${theme.borderSoft};
`;

export const FaqAccordionTrigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  padding: 20px 0; /* py-5 */
  border: none;
  background: transparent;
  color: ${theme.foreground};
  font-family: inherit;
  font-size: 1rem; /* text-base */
  font-weight: ${typography.weights.semibold};
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  cursor: pointer;
  transition: color 0.2s ease;

  @media (min-width: 768px) {
    font-size: 1.125rem; /* text-lg */
  }

  &:hover {
    color: ${theme.primary};
    text-decoration: none;
  }

  .material-icons {
    flex-shrink: 0;
    color: ${theme.textMuted};
    font-size: 20px;
    transition: transform 0.2s ease, color 0.2s ease;
  }

  &[aria-expanded="true"] {
    color: ${theme.primary};

    .material-icons {
      color: ${theme.primary};
      transform: rotate(180deg);
    }
  }
`;

export const FaqAccordionPanel = styled.div`
  overflow: hidden;
  max-height: 0;
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  transition: max-height 0.25s ease, opacity 0.2s ease;
`;

export const FaqAnswer = styled.div`
  padding-bottom: 24px;
  color: ${theme.textMuted};
  font-size: 1rem; /* text-base */
  font-weight: ${typography.weights.normal};
  line-height: 1.625;
  letter-spacing: ${typography.tracking.normal};

  p {
    margin: 0 0 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const FaqTermsList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 12px;
  color: ${theme.textMuted};
`;

export const FaqTermsLink = styled.a`
  color: ${theme.primary};
  font-size: 1rem;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const FaqCta = styled.section`
  position: relative;
  padding: 80px 16px;
  overflow: hidden;
  text-align: center;
`;

export const FaqCtaBg = styled.div`
  pointer-events: none;
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    hsl(32 95% 55% / 0.1) 0%,
    ${theme.bg} 50%,
    hsl(32 80% 45% / 0.05) 100%
  );
`;

export const FaqCtaInner = styled.div`
  position: relative;
  z-index: 1;
  max-width: 768px;
  margin: 0 auto;
`;

export const FaqCtaTitle = styled.h2`
  margin: 0 0 24px;
  color: ${theme.foreground};
  font-family: ${typography.fontFamily};
  font-size: 1.875rem; /* text-3xl */
  font-weight: ${typography.weights.bold};
  line-height: 1.25;
  letter-spacing: ${typography.tracking.tight};

  @media (min-width: 768px) {
    font-size: 3rem; /* text-5xl */
  }

  span {
    ${gradientTextStyles}
  }
`;

export const FaqCtaLead = styled.p`
  margin: 0 0 32px;
  color: ${theme.textMuted};
  font-size: 1.125rem;
  font-weight: ${typography.weights.normal};
  line-height: 1.625;
  letter-spacing: ${typography.tracking.normal};
`;

export const FaqCtaButton = styled(PrimaryButton)`
  min-height: 56px;
  padding: 0 36px;
  font-size: 1rem;
`;
